import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Admin_Parivartan_Delete_SubCategory } from "../../../../constants";
import axios from "axios";

const priorities = [
  { label: "High", color: "#00B050" },
  { label: "Medium", color: "#FFFF00" },
  { label: "Low", color: "#FF0000" },
];

const SubCategoryTable = ({
  subCategoryList,
  loading,
  setLoading,
  onRefresh,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [SubCategoryName, setSubCategoryName] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);

  const handleDeleteCategory = async () => {
    if (!selectedSubCategoryId) return;

    try {
      setLoading(true);
      const response = await axios.delete(
        `${Admin_Parivartan_Delete_SubCategory}/${selectedSubCategoryId}`
      );

      if (response.status === 200) {
        console.log("SubCategory deleted successfully");
        setDeleteModalOpen(false);
        onRefresh();
      } else {
        console.error("Failed to delete category");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      // <div>Loading region assignments...</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <CircularProgress size={24} sx={{ mr: 2 }} />
        <Typography>Loading Categories...</Typography>
      </Box>
    );
  }

  if (!subCategoryList || subCategoryList.length === 0) {
    return (
      // <div>No region assignments found.</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <Typography>No Categories found.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden", mt: 1 }}>
        <Box p={0}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 600 }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Priority</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Created On</TableCell>
                  <TableCell sx={{ fontWeight: 600 }} align="right">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subCategoryList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={48}
                          height={48}
                          fill="none"
                          viewBox="0 0 24 24"
                          style={{ color: "#bdbdbd", marginBottom: 8 }}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <Typography color="text.secondary">
                          No SubCatgories found
                        </Typography>
                        <Typography variant="body2" color="text.disabled">
                          Try adjusting your search or filters
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  subCategoryList.map((subcategory, index) => (
                    <TableRow
                      key={subcategory.SubCategoryId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                        "&:hover": {
                          backgroundColor: "#f1f1f1",
                          cursor: "pointer",
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontFamily: "monospace",
                          borderTopLeftRadius: "8px",
                          borderBottomLeftRadius: "8px",
                        }}
                      >
                        {subcategory.SubCategoryId}
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {subcategory.SubCategoryName}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: 12,
                              height: 12,
                              backgroundColor: subcategory.PriorityColor,
                              borderRadius: "50%",
                              marginRight: 8,
                            }}
                          />
                          {subcategory.Priority}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Tooltip title={subcategory.category.CategoryName}>
                          <Typography variant="body2">
                            {subcategory.category.CategoryName}
                          </Typography>
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        <Typography
                          variant="body2"
                          sx={{ fontFamily: "monospace" }}
                        >
                          {new Date(subcategory.CreatedAt).toLocaleDateString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </Typography>
                      </TableCell>

                      <TableCell
                        align="right"
                        sx={{
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                        }}
                      >
                        <Button
                          size="small"
                          variant="outlined"
                          color="warning"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSubCategoryId(subcategory.SubCategoryId);
                            setSubCategoryName(subcategory.SubCategoryName);
                            setDeleteModalOpen(true);
                          }}
                          sx={{
                            textTransform: "none",
                            borderRadius: "20px",
                            fontWeight: 500,
                            px: 2,
                          }}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Sub-Category</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the category{" "}
            <Box component="span" fontWeight="bold" display="inline">
              {SubCategoryName}
            </Box>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteModalOpen(false)}
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCategory}
            color="error"
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubCategoryTable;
